<contacttounit-menu (outputDownload)="downloadContacttounitFiltered()" (onReload)="onReload()"></contacttounit-menu>
<h2>{{title}} for {{defaults.tenant}}</h2>

<contacttounit-filter (outputFilter)="getFilteredContractsByTenant()"></contacttounit-filter>
<contacttounit-list [list]="list" [showLocalFilter]="showLocalFilter"></contacttounit-list>
